import type { SVGProps } from "react";

/**
 * Plain <svg>, not an MUI SvgIcon like its siblings: Emotion would inject a <style> into
 * server-rendered button markup.
 */
const FastForwardIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M5.58 16.89l5.77-4.07c.56-.4.56-1.24 0-1.63L5.58 7.11C4.91 6.65 4 7.12 4 7.93v8.14c0 .81.91 1.28 1.58.82zM13 7.93v8.14c0 .81.91 1.28 1.58.82l5.77-4.07c.56-.4.56-1.24 0-1.63l-5.77-4.07c-.67-.47-1.58 0-1.58.81z" />
  </svg>
);

export default FastForwardIcon;
